import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { axiosDelete, axiosGet, axiosPost } from "../../../../utils/APIHelper";
import { Bookmarkplans, BookmarkPlanState } from "./Bookmark";

const initialState: BookmarkPlanState = {
  list: [],
  status: "idle",
  totalRecords: 0,
  bookmarkedPlansList: [],
  bookmarkShowLoader: false
};

export const fetchBookmarkPlansIdAsync = createAsyncThunk("Library/bookmarkedPlans", async (thunkApi) => {
  const API_URL = "bookmarks";
  const response: any = await axiosGet(API_URL);
  return response.data.bookmarkedPlans;
});

export const fetchBookmarkPlansAsync = createAsyncThunk("Library/fetchbookmarkedPlans", async (data: {}, thunkApi) => {
  const API_URL = "plans";
  const response: any = await axiosPost(API_URL, "", {
    ...data
  });
  return response.data;
});

export const bookmarkPlan = createAsyncThunk("Library/createBookmark", async (data: {}, thunkApi) => {
  const API_URL = "bookmarks";
  const response: any = await axiosPost(API_URL, "library", {
    ...data
  });
  return response.data;
});

export const removeBookmarkPlan = createAsyncThunk("Library/removebookmarkedPlan", async (data: {}, thunkApi) => {
  const API_URL = "bookmarks";

  await axiosDelete(API_URL, undefined, data);
  return "success";
});

export const BookmarkedPlanSlice = createSlice({
  name: "bookmarkPlan",
  initialState,
  reducers: {
    removeBookmarkedPlan(state, action) {
      const bookmarkPlans = state.bookmarkedPlansList.filter((plan) => plan.id !== action.payload);
      state.bookmarkedPlansList = bookmarkPlans;
    },
    setBookmarkedPlanList(state) {
      state.bookmarkedPlansList = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBookmarkPlansIdAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchBookmarkPlansIdAsync.fulfilled, (state, action: PayloadAction<Bookmarkplans[]>) => {
        state.status = "idle";
        state.list = action.payload;
      })
      .addCase(fetchBookmarkPlansIdAsync.rejected, (state) => {
        state.status = "idle";
        state.list = [];
      })
      .addCase(fetchBookmarkPlansAsync.pending, (state, action: any) => {
        state.bookmarkShowLoader = action.meta.arg.pagination.page === 1;
        state.status = action.meta.arg.pagination.page === 1 ? "loading" : "idle";
      })
      .addCase(fetchBookmarkPlansAsync.fulfilled, (state, action: any) => {
        state.bookmarkShowLoader = false;
        state.status = "idle";
        state.totalRecords = action.payload.meta?.page?.total;
        state.bookmarkedPlansList =
          action.meta.arg.pagination.page === 1
            ? action.payload.plans
            : [...state.bookmarkedPlansList, ...action.payload.plans];
      })
      .addCase(fetchBookmarkPlansAsync.rejected, (state) => {
        state.status = "failed";

        state.bookmarkShowLoader = false;
        state.bookmarkedPlansList = [];
      });
  }
});

export const { removeBookmarkedPlan, setBookmarkedPlanList } = BookmarkedPlanSlice.actions;

export default BookmarkedPlanSlice.reducer;
